import { ArrowRightOutlined, EyeOutlined, } from '@ant-design/icons';
import { Button, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import dayjs from 'dayjs';
import { MatrialFilterFormValuesPaginated } from 'features/master/components/master-filter-form';
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { getRoute } from 'routes/utils';
import { VehicleLog } from 'types/vehicle';

type VehicleTableProps = {
    isvehicleListLoading: boolean;
    vehicleList: VehicleLog[];
    itemsCount: number;
    tableParams: MatrialFilterFormValuesPaginated;
    updateParams: Dispatch<SetStateAction<MatrialFilterFormValuesPaginated>>;
    setUserEditData: any;
    setShowAppUserModal: any;
    onRefresh :  () => void ;
  isFetching : boolean ;
};


export const EntryLogTable = ({
    vehicleList,
    isvehicleListLoading,
    itemsCount,
    tableParams,
    updateParams,
    onRefresh ,
  isFetching
}: VehicleTableProps) => {
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<VehicleLog> | SorterResult<VehicleLog>[]
    ) => {

       
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };
    const navigate = useNavigate() ;

    const handleNigate = (item: any) => {
        navigate(getRoute(ROUTES.LOG_ADMIN_DETAIL, item.entryId));
    }

  
   
   
    return (
        <>

       
                
            <StyledTableWrapper>
                <StyledTableHeader>
                    <RecordCountBadge text={'Entry/Exit Logs'} count={itemsCount} />
                     <Button
                        type="link"                // 👈 makes it look like blue text
                        onClick={onRefresh}
                        loading={isvehicleListLoading}
                        style={{ padding: 0, marginBottom: 16 }}
                        >
                        Refresh Data
                        </Button>
                </StyledTableHeader>

                <Table<VehicleLog>
                    loading={(isvehicleListLoading || isFetching) && { indicator: <TableLoader /> }}
                    dataSource={vehicleList}
                    rowKey="id"
                    onChange={handleTableChange}
                    pagination={{
                        current: tableParams.page,
                        defaultPageSize: tableParams.size,
                        total: itemsCount,
                    }}
                >
                    <Column
                        key="detail"
                        title=""
                        dataIndex="detail"
                        render={() => (
                            <ArrowRightOutlined style={{ cursor: "pointer", fontSize: 16 }} />
                        )}
                        onCell={(record) => {
                            return {
                                style: { cursor: "pointer" }, // ensures cursor shows on hover
                                onClick: () => {
                                    const selection = window?.getSelection()?.toString();
                                    if (!selection?.length) {
                                        handleNigate(record); // ✅ navigate to details
                                    }
                                },
                            };
                        }}
                    />
                    <Column<VehicleLog> title={'Driver Name'} dataIndex={'driverName'} />
                    <Column<VehicleLog> title={'Vehicle Number'} dataIndex={'vNumber'} />  
                    <Column<VehicleLog> title={'Supplier/Customer Name'} dataIndex={'supplierName'} />
                    <Column<VehicleLog> title={'Entry Type'} dataIndex={'entryType'} />
                    <Column<VehicleLog>
                        title="Entry Date"
                        dataIndex="vInTime"
                        render={(value) =>
                            value ? dayjs(value).format("DD-MM-YYYY HH:mm") : "-"
                        }
                    />
                    <Column<VehicleLog>
                        title="Exit Date"
                        dataIndex="vOutTime"
                        render={(value) =>
                            value ? dayjs(value).format("DD-MM-YYYY HH:mm") : "-"
                        }
                    />
                    <Column<VehicleLog> title={'Status'} dataIndex={'status'} />
                    <Column<VehicleLog>
                        title="Action"
                        key="action"
                        render={(record) => (
                            <>
                                <span style={{ cursor: 'pointer' }} role='button' onClick={() => handleNigate(record)}>
                                    <EyeOutlined />
                                </span>
                            </>
                        )}
                    />
                </Table>
            </StyledTableWrapper>
        </>
    );
};
